export default __webpack_public_path__ + "static/media/create-share.b2a183a5.svg";